import { createApp } from 'vue'
import { createPinia, setActivePinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'

import App from '@/App.vue'
import { router } from '@/router'
import { transportKey } from '@/api/keys'
import { createTransport } from '@/api/transport'
import { useAuthStore } from '@/stores/auth'
import { loadRuntimeConfig } from '@/composables/useRuntimeConfig'
import '@/styles/main.css'

// Fetch runtime config + hydrate the auth store BEFORE mounting so the
// header renders the right links and Sign-in/user state on first paint —
// no visible flash between "logged out" and "logged in" shell.
const boot = async () => {
  const app = createApp(App)

  const pinia = createPinia()
  app.use(pinia)
  // Activate Pinia before the router's beforeEach guards run so useAuthStore()
  // works outside a component context during the pre-mount hydration step.
  setActivePinia(pinia)
  await loadRuntimeConfig()
  app.use(router)
  app.use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: { staleTime: 30_000, retry: 1 },
      },
    },
  })

  const pendingRefresh = () => useAuthStore().refresh()
  app.provide(
    transportKey,
    createTransport({
      baseUrl: window.location.origin,
      refreshHook: pendingRefresh,
    }),
  )

  const auth = useAuthStore()
  await auth.ensureLoaded()

  await router.isReady()
  app.mount('#app')
}

void boot()
